import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import { showTutorial } from '../tutorial.util';

export class CatalogTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'catalog';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'catalogOpen') {
      return false;
    }

    // Show tutorial popup and grant rewards
    await showTutorial('catalog', {
      $stepIndex: 23,
      $stepName: 'catalog',
    });

    return true;
  }
}
